export const cinemaAssets = {
  activationPaper: '/assets/cinema-paper-bg-v5.webp',
  homePaper: '/assets/home-paper-bottom-v1.webp',
  topFilm: '/assets/cinema-top-filmstrip-v2.webp',
  stamp: '/assets/soul-film-camera-stamp-v2.webp',
  activationBottom: '/assets/activation-bottom-corners-v2.webp',
  activationTitle: '/assets/activation-title-art-v3.webp',
  activationHero: '/assets/activation-curled-film-hero-v3.webp',
  homeTitle: '/assets/home-title-art-v3.webp',
  homeHero: '/assets/home-curled-film-hero-v3.webp',
} as const
